import GrupoEconomicoList from './GrupoEconomicoList'

export default {
  list: GrupoEconomicoList,
}
